import { companyLogos } from "../constants";

const CompanyLogos = ({ className }) => {
  return (
    <div className={className}>
      <h5 className="tagline mb-8 text-center text-n-1/50 text-sm">
        Partners with leading companies
      </h5>
      <div className="flex flex-wrap justify-between gap-4">
        {companyLogos.map((item, index) => (
          <div
            className="flex items-center p-4 border border-n-1/10 rounded-xl bg-n-7 mb-8"
            key={index}
          >
            <div className="w-24 h-12 flex items-center justify-start">
              <img src={item.logo} alt={`Partner ${index + 1}`} className="max-h-full max-w-full object-contain" />
            </div>
            <p className="text-n-1 text-xs ml-2 whitespace-pre-line">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanyLogos;
